import type { StepProps } from '../types';
import { CurrencyField, ToggleField } from '../fields';

export default function RentalK1Step({ input, onChange }: StepProps) {
  return (
    <div className="space-y-8" data-tour="rental-step">
      <div data-tour="rental-property">
        <h3 className="text-sm font-semibold mb-4">Rental Property</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <ToggleField label="Rental Activity Active?" value={input.rentalActive} onChange={v => onChange('rentalActive', v)} />
          <CurrencyField label="Rental Income" value={input.rentalIncome} onChange={v => onChange('rentalIncome', v)} hint="Schedule E line 3 (rents received)" />
          <CurrencyField label="Rental Expenses" value={input.rentalTotalExpenses} onChange={v => onChange('rentalTotalExpenses', v)} hint="Schedule E line 20 (total expenses)" />
        </div>
      </div>

      <div data-tour="rental-k1">
        <h3 className="text-sm font-semibold mb-4">K-1 Partnership / S-Corp Income</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <CurrencyField label="K-1 Ordinary Business" allowNegative value={input.k1OrdinaryBusinessIncome} onChange={v => onChange('k1OrdinaryBusinessIncome', v)} hint="Schedule K-1 box 1" />
          <CurrencyField label="K-1 Guaranteed Pay" value={input.k1GuaranteedPayments} onChange={v => onChange('k1GuaranteedPayments', v)} hint="Schedule K-1 (1065) box 4c" />
          <CurrencyField label="K-1 Rental RE" allowNegative value={input.k1RentalRealEstateIncome} onChange={v => onChange('k1RentalRealEstateIncome', v)} hint="Schedule K-1 box 2" />
          <CurrencyField label="K-1 Other Income" allowNegative value={input.k1OtherIncome} onChange={v => onChange('k1OtherIncome', v)} hint="Schedule K-1 (1065) box 11 / (1120-S) box 10" />
        </div>
      </div>
    </div>
  );
}
